import React from "react";
import { useState } from 'react';
import { Modal } from "react-bootstrap";
import Webcam from "react-webcam";
import useWindowDimensions from "contexts/windowDimension";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Button from "components/CustomButtons/Button.js";
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import useAuth from "hooks/useAuth";
import api from "assets/services/api";

const styles = {
    fit: {
        height: "100%",
        overflow: "auto"
    },
    widthFull: {
        width: "100%"
    }
};

const useStyles2 = makeStyles(styles2);


function Camera(props) {
    console.log("props", props);
    const useStyles = makeStyles(styles);
    const { storageId } = useAuth();
    const { height, width } = useWindowDimensions();
    const classes = useStyles();
    const classes2 = useStyles2();

    const FACING_MODE_USER = "user";
    const FACING_MODE_ENVIRONMENT = "environment";

    const videoConstraints = {
        width: width,
        height: height,
        facingMode: FACING_MODE_USER
    };

    const [loading, setLoading] = useState(true);
    const [nf, setNf] = useState(props.props[0] ? props.props[0].nf : 0)
    const [facingMode, setFacingMode] = React.useState(FACING_MODE_USER);

    const webcamRef = React.useRef(null);

    const handleClick = React.useCallback(() => {
        setFacingMode(
            prevState =>
                prevState === FACING_MODE_USER
                    ? FACING_MODE_ENVIRONMENT
                    : FACING_MODE_USER
        );
    }, []);

    function base64ToBlob(base64, mime = 'image/png') {
        const byteString = atob(base64.split(',')[1]); // remove "data:image/png;base64,"
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mime });
    };

    async function sendImage(image) {
        try {
            const imagemBlob = base64ToBlob(image); // converte base64 para Blob
            if (!imagemBlob) {
                alert("Não foi possível capturar a imagem. Tente novamente.");
                return;
            }
            setLoading(false);
            const formData = new FormData();
            //const imagefile = document.querySelector("#file");
            formData.append('fileimage', imagemBlob);
            formData.append('id', storageId);

            const data = await api.post(`/file/receipt/for/app/test/for?nf=${nf}`, formData, {
                headers: {
                    "content-type": "multipart/form-data;",
                }
            });

            if (data.status === 200) {
                setLoading(true);
                alert(`O canhoto da nota fiscal de número: ` + nf + " foi enviado com sucesso!")
                props.loadSell();
                props.onHide();
            }
        } catch (error) {
            setLoading(true);
            alert("Não foi possível enviar o canhoto da nota fiscal de número: " + props.props.nf + " tente novamente. " + error)
        }
    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Tirar foto

                    <IconButton
                        aria-label="Edit"
                        className={classes2.tableActionButton}
                        onClick={handleClick}
                    >
                        <PhotoCamera />
                    </IconButton>
                </Modal.Title>

            </Modal.Header>
            <Modal.Body
                className=""
            >
                <div>
                    <Webcam
                        audio={false}
                        height="100%"
                        screenshotFormat="image/jpeg"
                        width="100%"
                        responseType="arrayBuffer"
                        ref={webcamRef}
                        videoConstraints={{
                            ...videoConstraints,
                            facingMode
                        }}
                    >
                        {({ getScreenshot }) => (
                            loading && <Button className={classes.widthFull} color="success" onClick={(e) => {
                                sendImage(getScreenshot({ width: 1000, height: 750 }))
                            }}>
                                Tirar foto
                            </Button>
                        )}
                    </Webcam>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default Camera;